var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseinline = function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CA0821",
    fillRule: "evenodd",
    d: "M12 13.663 4.663 21 3 19.337 10.337 12 3 4.663 4.663 3 12 10.337 19.337 3 21 4.663 13.663 12 21 19.337 19.337 21z"
  })));
};
export default SvgCloseinline;